import React from 'react';
import { useNavigate } from 'react-router-dom';
// 푸터 스타일은 LandingPage.css에 정의됨 — 어떤 페이지에서 쓰이든 스스로 로드
import '../../styles/pages/LandingPage.css';

/**
 * Footer - 랜딩 페이지 푸터
 */
function Footer() {
  const navigate = useNavigate();

  const handleInquiryClick = () => {
    navigate('/inquiry');
  };

  return (
    <footer className="landing-footer">
      <div className="landing-footer__container">
        {/* 상단 영역 */}
        <div className="landing-footer__top">
          {/* 왼쪽: 회사 정보 */}
          <div className="landing-footer__left">
            <p className="footer-text">상호: (주)카보</p>
            <p className="footer-text">대표: 이동진</p>
            <p className="footer-text">주소: 충청남도 계룡시 장안1길 6, 202호</p>
            <p className="footer-text">사업자번호: 291-86-02840</p>
            <p className="footer-text">전화: 044-715-7442</p>
            <div className="footer-links">
              <button 
                className="footer-link"
                onClick={() => window.open('/terms', '_blank')}
              >
                [이용약관]
              </button>
              <button 
                className="footer-link"
                onClick={() => window.open('/privacy-policy', '_blank')}
              >
                [개인정보 처리방침]
              </button>
              <button 
                className="footer-link"
                onClick={() => window.open('/refund-policy', '_blank')}
              >
                [환불정책]
              </button>
            </div>
          </div>

          {/* 가운데: 로고 */}
          <div className="landing-footer__center">
            <img 
              src="/images/logo.svg" 
              alt="셀프애드 로고" 
              className="landing-footer__logo"
            />
          </div>

          {/* 오른쪽: 영업 시간 & 문의 & Copyright */}
          <div className="landing-footer__right">
            <div className="footer-info-group">
              <p className="footer-text">영업 시간: 평일 09:00 ~ 17:00</p>
              <button 
                className="footer-link"
                onClick={handleInquiryClick}
              >
                [문의하기]
              </button>
            </div>
            <div className="footer-copyright-group">
              <p className="footer-copyright footer-copyright--inline">copyright 카보. All right Reserved</p>
              <p className="footer-copyright footer-copyright--inline">개인정보책임관리자: 이동진</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
